import MediaCaptureField from "./MediaCaptureField.js"

/**
 * Status-screen photo card. The shared picker shows one small preview.
 */
const CapturePhotoField = ({
  label,
  required = false,
  file = null,
  onPick,
  onClear,
  disabled = false,
  compact = false,
}) => {
  if (compact) {
    return (
      <div className="min-w-[8.5rem] flex-[1_1_10rem]">
        <p className="text-xs font-semibold text-gray-800 mb-1 leading-tight">
          {label}
          {required ? <span className="text-red-500"> *</span> : null}
        </p>
        <MediaCaptureField
          mode="photo"
          compact
          disabled={disabled}
          onPick={onPick}
          onClear={onClear}
          selectedFile={file}
        />
      </div>
    )
  }

  return (
    <div className="min-w-0 rounded-xl border border-gray-200 bg-white p-3">
      <p className="text-sm font-semibold text-blue-900 mb-2">
        {label} {required ? <span className="text-red-500">*</span> : null}
      </p>
      <MediaCaptureField
        mode="photo"
        disabled={disabled}
        onPick={onPick}
        onClear={onClear}
        selectedFile={file}
      />
      <p className="text-[10px] sm:text-xs text-gray-500 text-center mt-2">
        Take a photo with the camera, or upload from gallery.
      </p>
    </div>
  )
}

export default CapturePhotoField
